module.exports = __webpack_public_path__ + "static/img/food.9b9e9ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/food.png
// module id = 100
// module chunks = 1